import React from 'react';
import { Button } from './ui/button';
import { Calendar, Users, Clock, MapPin } from 'lucide-react';

const ProductCard = ({ product, category, className = '' }) => {
  // Default placeholder image if none provided  
  const defaultImage = '/Laksh Space Logo.png';
  
  // Get appropriate icon based on features or category
  const getFeatureIcon = (feature) => {
    if (feature.toLowerCase().includes('month') || feature.toLowerCase().includes('year')) {
      return <Calendar size={16} className="text-gray-600" />;
    }
    if (feature.toLowerCase().includes('team') || feature.toLowerCase().includes('people')) {
      return <Users size={16} className="text-gray-600" />;
    }
    if (feature.toLowerCase().includes('hour') || feature.toLowerCase().includes('day')) {
      return <Clock size={16} className="text-gray-600" />;
    }
    return <MapPin size={16} className="text-gray-600" />;
  };

  const handlePrimaryAction = () => {
    // Handle primary CTA (Get a quote, Get a quote, etc.)
    window.location.href = 'https://wa.me/919972235566';
    // You can add actual functionality here like opening a modal, redirecting, etc.
  };

  const handleSecondaryAction = () => {
    // Handle secondary CTA (Learn more, View details, etc.)
    window.location.href = '/#/contact';
    // You can add actual functionality here
  };

  return (
    <div className={`bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden ${className}`}>
      {/* Image Section */}
      <div className="relative h-48 overflow-hidden">
        <img 
          src={product.image || defaultImage} 
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
          onError={(e) => {
            e.target.src = defaultImage;
          }}
        />
        {product.availability && (
          <div className="absolute top-3 right-3 bg-[#e30613] text-white text-xs font-semibold px-2 py-1 rounded-full">
            {product.availability}
          </div>
        )}
      </div>

      {/* Content Section */}
      <div className="p-6">
        {/* Header */}
        <div className="mb-4">
          <h3 className="text-xl font-bold text-gray-900 mb-2 leading-tight">
            {product.name}
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            {product.description}
          </p>
        </div>

        {/* Features */}
        {product.features && product.features.length > 0 && (
          <div className="mb-4 space-y-2">
            {product.features.map((feature, index) => (
              <div key={index} className="flex items-center space-x-2 text-sm text-gray-700">
                {getFeatureIcon(feature)}
                <span>{feature}</span>
              </div>
            ))}
          </div>
        )}

        {/* Pricing */}
        {product.pricing && (
          <div className="mb-6">
            <p className="text-lg font-semibold text-gray-900">
              {product.pricing} +GST
            </p>
          </div>
        )}

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3">
          <Button 
            onClick={handlePrimaryAction}
            className="bg-[#e30613] hover:bg-[#c1050f] text-white font-bold rounded-md flex-1 transition-colors"
          >
            {product.ctaText || 'Get a quote'}
          </Button>
          
          {product.ctaSecondary && (
            <Button 
              onClick={handleSecondaryAction}
              variant="outline"
              className="border-[#e30613] text-[#e30613] hover:bg-[#e30613] hover:text-white font-bold rounded-md flex-1 transition-colors"
            >
              {product.ctaSecondary}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;